import { visibleNavSections, percorsiDiVoce } from './navConfig';

// Where a signed-in user starts.
//
// By default everyone lands on `/news` except `SUPER_ADMIN` (`/home`).
// When `accesso` (`{ permessi, catalogo }`) is provided, `landingPath` verifies
// that the default landing route is actually permitted (e.g. if `/news` was
// explicitly negated via `consentito: false`), falling back through `/home`,
// `/dashboard`, `/pratiche`, or the first permitted route in `visibleNavSections`.
// Returns `null` if every section in the navigation tree has been disabled.
export const landingPath = (user, accesso = null) => {
  if (!user) return '/login';
  if (user.ruolo === 'SUPER_ADMIN') return '/home';
  if (!accesso) return '/news';

  const visibili = visibleNavSections(user, accesso)
    .flatMap((s) => s.items)
    .flatMap(percorsiDiVoce);
  if (visibili.length === 0) return null;

  const preferiti = ['/news', '/home', '/dashboard', '/pratiche'];
  for (const candidato of preferiti) {
    if (visibili.includes(candidato)) return candidato;
  }
  return visibili[0];
};

export default landingPath;
